import { get } from '../client/axiosClient';
import { stateProvinceEndpoints } from '../endpoints/stateProvince.endpoints';
import type { ApiResponse, StateProvince } from '../types';

class StateProvinceService {
  async getAll(): Promise<ApiResponse<StateProvince[]>> {
    const response = await get<any>(stateProvinceEndpoints.list());
    const raw = response.data;
    return { success: raw?.success ?? false, message: raw?.message, data: raw?.data ?? [] };
  }

  async getByCountry(countryId: string): Promise<ApiResponse<StateProvince[]>> {
    const response = await get<any>(stateProvinceEndpoints.byCountry(countryId));
    const raw = response.data;
    return { success: raw?.success ?? false, message: raw?.message, data: raw?.data ?? [] };
  }
}

export const stateProvinceService = new StateProvinceService();
export default stateProvinceService;
